/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Utils from '../utils/utils';
import { PRIVATE_PATH } from '../constants';

const ProtectedManagementCompanySectionRoute = ({ component: Component, ...rest }) => {
	const pathPermissions = Array.isArray(rest.pathPermission) ? rest.pathPermission : [rest.pathPermission];
	const isAuthorized = pathPermissions.some((pathPermission) =>
		Utils.isGlobalManagementCompanyAuthorized(pathPermission, rest.operation, rest.globalManagementCompanyPermissions)
	);

	return (
		<Route {...rest} render={() => (isAuthorized ? <Component {...rest} /> : <Redirect to={PRIVATE_PATH.SHIFTS} />)} />
	);
};

export default ProtectedManagementCompanySectionRoute;
